import React from 'react';

const ContactInfoCard = ({ settings, onChange }) => (
  <div className="bg-white rounded-xl shadow p-6">
    {/* 分区块一：基础联系方式 */}
    <h3 className="font-semibold mb-4">联系方式</h3>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium mb-1">电话</label>
        <input type="text" value={settings.phone}
          onChange={e => onChange('phone', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">邮箱</label>
        <input type="email" value={settings.email}
          onChange={e => onChange('email', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500" />
      </div>
      <div className="md:col-span-2">
        <label className="block text-sm font-medium mb-1">地址</label>
        <input type="text" value={settings.address}
          onChange={e => onChange('address', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Facebook</label>
        <input type="text" value={settings.facebook}
          onChange={e => onChange('facebook', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          placeholder="https://facebook.com/..." />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Telegram</label>
        <input type="text" value={settings.telegram}
          onChange={e => onChange('telegram', e.target.value)}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          placeholder="@yourshop" />
      </div>
    </div>

    {/* 分区块二：客服系统——和上面的基础联系方式用分隔线+小标题区分开，
        避免两组性质不同的信息（一个是店铺自己的联系方式，一个是第三方系统对接参数）
        看起来像混在一起的一长串输入框 */}
    <div className="mt-6 pt-6 border-t border-gray-100">
      <h3 className="font-semibold mb-1">客服系统</h3>
      <p className="text-xs text-gray-400 mb-4">对接第三方在线客服（EasyLink），让H5商城客户能直接联系客服咨询</p>

      <div className="grid grid-cols-1 gap-4">
        {/* app_key——必填才能启用客服，留空表示这个租户不使用客服功能 */}
        <div>
          <label className="block text-sm font-medium mb-1">
            app_key
            <span className="text-gray-400 text-xs font-normal ml-1">（这两项都留空表示不启用客服功能；要启用客服，这项必须填）</span>
          </label>
          <input type="text" value={settings.customer_service_app_key || ''}
            onChange={e => onChange('customer_service_app_key', e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="在 console.easylink.xin 的接入设置里获取" />
          <p className="text-xs text-gray-400 mt-1">
            还没有客服账号？前往
            <a href="https://console.easylink.xin" target="_blank" rel="noopener noreferrer"
              className="text-blue-600 hover:underline mx-1">
              console.easylink.xin
            </a>
            自助注册，注册完成后在"接入设置"里找到 app_key 填在这里
          </p>
          <p className="text-xs text-amber-600 mt-1">
            ⚠️ 光填 app_key 还不够，还需要在 EasyLink 控制台的"域名白名单"里，把自己H5商城的域名也加进去（只填域名本身，不要带 https:// 前缀），否则客服窗口加载不出来
          </p>
        </div>

        {/* app_secret——选填，不是必须配置的字段。不填的话客服功能本身完全
            不受影响（依然能正常聊天），只是客服人员看到的是"匿名访客"，
            不知道具体是哪个会员在咨询。填了之后，客服才能识别出会员身份（ID、昵称），
            方便核实老客户、查订单记录。这个值绝不会传到浏览器/H5端，只在服务器内部
            用来生成签名，请求发出去之前不会经过任何前端代码 */}
        <div>
          <label className="block text-sm font-medium mb-1">
            app_secret
            <span className="text-gray-400 text-xs font-normal ml-1">
              （选填——不填客服照样能用，只是客服看到的是"匿名访客"；填了才能让客服识别出具体是哪个会员在咨询）
            </span>
          </label>
          <input type="password" value={settings.customer_service_app_secret || ''}
            onChange={e => onChange('customer_service_app_secret', e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="和 app_key 在同一个页面获取，妥善保管，不要泄露给他人" />
          <p className="text-xs text-gray-400 mt-1">
            这个值只会保存在服务器里，绝不会出现在网页前端或者发给客户的任何内容里，可以放心填写
          </p>
        </div>
      </div>
    </div>

    {/* 分区块三：第三方平台SSO对接（简捷网等） */}
    <div className="mt-6 pt-6 border-t border-gray-100">
      <h3 className="font-semibold mb-1">第三方平台对接</h3>
      <p className="text-xs text-gray-400 mb-4">给合作的第三方平台（如简捷网）用的免登录SSO密钥，让对方的用户跳转进商城时能自动登录，不用重新输账号密码</p>

      <div className="grid grid-cols-1 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">
            app_key
            <span className="text-gray-400 text-xs font-normal ml-1">（对方生成/发放，不填则不启用对接）</span>
          </label>
          <input type="text" value={settings.sso_partner_key || ''}
            onChange={e => onChange('sso_partner_key', e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="第三方平台分配的app_key" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">
            app_secret
            <span className="text-gray-400 text-xs font-normal ml-1">（对方生成/发放，用于验证对方请求签名）</span>
          </label>
          <input type="password" value={settings.sso_partner_secret || ''}
            onChange={e => onChange('sso_partner_secret', e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="第三方平台分配的app_secret，妥善保管" />
          <p className="text-xs text-gray-400 mt-1">
            这个值只会保存在服务器里，绝不会出现在网页前端或者发给客户的任何内容里，可以放心填写
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default ContactInfoCard;